<template>
  <div>
    <h2 class="text-left alert" :class="[removed ? 'alert-danger' : 'alert-success']">
      Historic Milk Production
      <a class="btn btn-sm" @click="$emit('onRemoveSection', stepName)">
        <span class="glyphicon" :class="[removed ? 'glyphicon-plus' : 'glyphicon-remove']"></span>
      </a>
    </h2>
    <template v-if="!removed">
      <report-comment field_name="heading_historic_milk_production" :model="model.COMMENTS" :heading="true">
      </report-comment>

      <subsection title="Historic Milk Production" :step-name="stepName" subsection="historic_milk_production">
        <div
          class="step-section"
          v-for="(data, index) in model.CHARTS.historic_milk_production"
          :key="'histo_' + index"
        >
          <h3 class="text-left">{{ data.Shed }}</h3>
          <table class="table table-bordered">
            <tbody>
              <tr>
                <td width="70%">
                  Predicted Total Production {{ seasonStartYear - 1 }}/{{ seasonStartYear.toString().substr(-2) }} KgMS
                </td>
                <td width="30%">{{ data['Predicted Total Production KgMS Last Season'] }}</td>
              </tr>
              <tr>
                <td width="70%">
                  Predicted Per Cow Production {{ seasonStartYear - 1 }}/{{
                    seasonStartYear.toString().substr(-2)
                  }}
                  KgMS
                </td>
                <td width="30%">{{ data['Predicted Per Cow Production KgMS last Season'] }}</td>
              </tr>
              <tr>
                <td width="70%">
                  Actual Total Production {{ seasonStartYear - 2 }}/{{ seasonStartYear.toString().substr(-2) - 1 }} KgMS
                </td>
                <td width="30%">{{ data['Actual Total Production KgMS Pervious Season'] }}</td>
              </tr>
              <tr>
                <td width="70%">
                  Actual Per Cow Production {{ seasonStartYear - 2 }}/{{
                    seasonStartYear.toString().substr(-2) - 1
                  }}
                  KgMS
                </td>
                <td width="30%">{{ data['Actual Per Cow Production KgMS Previous Season'] }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </subsection>

      <subsection
        :title="farm.farm_label"
        :step-name="stepName"
        :subsection="`farm_${farm.id}-historic_milk_production`"
        v-for="farm in model.FARMS"
        :key="farm.id"
      >
        <dl class="dl-horizontal">
          <dt>Actual Total Production {{ seasonStartYear - 1 }}/{{ seasonStartYear.toString().substr(-2) }} Kg/MS</dt>
          <dd>{{ model[`farm_${farm.id}-kgms_ls`] || '-' }}</dd>
          <report-comment :field_name="`farm_${farm.id}-kgms_ls`" :model="model.COMMENTS"></report-comment>

          <dt>Target Total Production {{ seasonStartYear }}/{{ (seasonStartYear + 1).toString().substr(-2) }} Kg/MS</dt>
          <dd>{{ model[`farm_${farm.id}-pred_kgms_ts`] || '-' }}</dd>
          <report-comment :field_name="`farm_${farm.id}-pred_kgms_ts`" :model="model.COMMENTS"></report-comment>
        </dl>
      </subsection>
    </template>
  </div>
</template>

<script>
import mixin from './mixin'

export default {
  mixins: [mixin],
  name: 'HistoricProduction',
}
</script>
